import styled from 'styled-components';
import { themeGet, getBackgroundColor, getTextColor } from '@magalu/stereo-ui-styles';
import { Box, Link } from '../../atoms';
export const Table = styled(Box).attrs(props => Object.assign({
  forwardedAs: 'table'
}, props))`
  list-style: none;

  tbody > tr > td {
    padding: 5px;
  }
`;
export const TableTitle = styled.td`
  font-weight: bold;
  color: ${props => themeGet('colors.darkSilver')(props)};
  background: ${props => getBackgroundColor('base')(props)};
  display: ${({
  layout
}) => layout === 'horizontal' ? 'table-cell' : 'list-item'};
  width: ${({
  layout
}) => layout === 'horizontal' ? '20%' : '100%'};
`;
export const TableContainer = styled.td`
  display: list-item;
  width: 100%;
  padding: 5px;
`;
export const Name = styled.td`
  width: 40%;
`;
export const InnerTable = styled.table`
  width: 100%;
  td:first-child {
    display: table-cell;
  }
  tr {
    display: table-row;
    vertical-align: middle;
  }
`;
export const InnerTableLink = styled(Link)`
  text-decoration: underline;
  font-size: inherit;

  &:hover {
    color: ${props => getTextColor('primary')(props)};
  }
`;